import { shape, string } from 'prop-types';

export default shape({
  href: string,
  label: string,
  color: string,
  variant: string,
});
